import React, { useEffect, useState } from 'react';
import Categories from './Categories';
import Types from './Types';
import Journals from './Journals';
import Modal from '../../Modal';

const Filters = ({ categories, contentTypes, journals, updateTypes, updateCategories, updateJournals, categoryIds, journalIds, submitUpdate, modal, id, categoryIdPreSelected }) => {
  const [filteredCategories, setFilteredCategories] = useState(categoryIds);
  const [journalCategoryMap, setJournalCategoryMap] = useState({});
  const [updatedJournals, setUpdatedJournals] = useState({}); // Track updated journals

  const checkedLength = (elements) => {
    return Object.values(elements).filter((obj) => obj.checked && obj.id !== 0).length;
  };


  useEffect(() => {
    fetch('/journals/journal_category_map')
      .then(response => response.json())
      .then(data => {
        setJournalCategoryMap(data);
      })
      .catch(error => console.error('Error fetching journal-category map:', error));
  }, []);

const selectedJournalIds = Object.keys(updatedJournals).filter(id => updatedJournals[id].checked);
useEffect(() => {
  const selectedJournalIds = Object.keys(updatedJournals).filter(id => updatedJournals[id].checked);

  if (selectedJournalIds.length > 0 && Object.keys(journalCategoryMap).length > 0) {
    const newFilteredCategories = categoryIds.filter(catId => {
      return selectedJournalIds.some(journalId => journalCategoryMap[journalId]?.includes(catId));
    });

    setFilteredCategories(newFilteredCategories);

    const updatedCategories = { ...categories };
    Object.keys(updatedCategories).forEach(catId => {
      updatedCategories[catId].checked = newFilteredCategories.includes(catId);
    });
    updateCategories(updatedCategories);
  } else {
    setFilteredCategories(categoryIds);

    const updatedCategories = { ...categories };
    Object.keys(updatedCategories).forEach(catId => {
      updatedCategories[catId].checked = false;
    });
    updateCategories(updatedCategories);
  }
}, [journalIds, journalCategoryMap, categoryIds, updatedJournals]);

  const submitUpdateWrapper = () => {
    if (modal) {
      Modal.close();
    }
        
    submitUpdate();
  };

  return (
    <div id={id} className={(modal ? "new-articles-index" : "small-12 columns show-for-large-up") + " left-sidebar"}>
      <Journals
        journals={journals}
        journalIds={journalIds}
        updateJournals={(updated) => {
          setUpdatedJournals(updated);
          updateJournals(updated);
        }}
        checkedLength={checkedLength}
        id={id}
      />
      <Types
        contentTypes={contentTypes}
        updateTypes={updateTypes}
        checkedLength={checkedLength}
        id={id}
      />
      {/* {!categoryIdPreSelected && (
        <Categories
          categories={categories}  // Use filtered categories
          categoryIds={filteredCategories}
          updateCategories={updateCategories}
          checkedLength={checkedLength}
          id={id}
        />
      )} */}
      <a className="button small apply" onClick={submitUpdateWrapper}>Apply</a>
    </div>
  );
};

export default Filters;